var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6208 4.90431C2.8748 4.62721 3.30534 4.60849 3.58244 4.8625L11.29 11.9278L18.9976 4.8625C19.2747 4.60849 19.7052 4.62721 19.9593 4.90431C20.2133 5.1814 20.1945 5.61194 19.9174 5.86595L11.7499 13.3528C11.4897 13.5914 11.0903 13.5914 10.8301 13.3528L2.66261 5.86595C2.38551 5.61194 2.36679 5.1814 2.6208 4.90431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.44189 5.36422C2.44189 4.98832 2.74662 4.68359 3.12252 4.68359H19.4575C19.8334 4.68359 20.1381 4.98832 20.1381 5.36422V16.9348C20.1381 17.2959 19.9947 17.6421 19.7394 17.8974C19.4842 18.1527 19.1379 18.2961 18.7769 18.2961H3.80314C3.44212 18.2961 3.09588 18.1527 2.8406 17.8974C2.58531 17.6421 2.44189 17.2959 2.44189 16.9348V5.36422ZM3.80314 6.04484V16.9348H18.7769V6.04484H3.80314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3027 11.0292C10.5568 11.3062 10.5382 11.7368 10.2611 11.9908L3.7952 17.9208C3.51817 18.1749 3.08762 18.1562 2.83355 17.8792C2.57948 17.6022 2.5981 17.1716 2.87514 16.9176L9.34107 10.9876C9.61811 10.7335 10.0487 10.7522 10.3027 11.0292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2773 11.0292C12.5313 10.7522 12.9619 10.7335 13.2389 10.9876L19.7049 16.9176C19.9819 17.1716 20.0005 17.6022 19.7464 17.8792C19.4924 18.1562 19.0618 18.1749 18.7848 17.9208L12.3189 11.9908C12.0418 11.7368 12.0232 11.3062 12.2773 11.0292Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8834f617a98e76dee69f53c41942686e.svg";
export { ForwardRef as ReactComponent };